<template>
  <div class="activity-country-nav-list">
    <el-tabs class="nav-list-left" v-model="innerValue" @tab-click="_updateActiveBar()">
      <el-tab-pane v-for="(nav,index) in navList" :key="index" :label="nav.label" :name="nav.value"></el-tab-pane>
    </el-tabs>

    <div class="nav-list-right">
      <slot></slot>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
    showOptionAll: {
      type: Boolean,
      default: false,
    },
    labelKey: {
      type: String, 
      default: 'label',
    },
    valueKey: {
      type: String, 
      default: 'value',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    innerValue: {
      get() {
        return this.value || 'all';
      },
      set(value) {
        this.$emit('input', value && value !== 'all' ? value : undefined);
      },
    },
    navList() {
      if (!this.list || !this.list.length) return [];

      const optionAll = {
        label: '全部',
        value: 'all',
      };

      let navList = [];
      if (typeof this.list[0] === 'string') {
        navList = this.list.map(item => ({ label: item, value: item }));
      } else if (Object.prototype.toString.call(this.list[0]) === '[object Object]') {
        navList = this.list.map(item => ({ label: item[this.labelKey], value: item[this.valueKey] }));
      }
      
      if (this.showOptionAll) {
        navList.unshift(optionAll);
      }

      return navList;
    },
  },
  mounted() {
    this._updateActiveBar();
  },
  watch: {
    list: {
      handler(val) {
        // 变化需要重置滚动条位置
        this._updateActiveBar();
      },
    },
  },
  methods: {
    _updateActiveBar() {
      this.$nextTick(() => {
        const activeContinentBottom = this.$el.querySelector('.el-tabs__active-bar');
        const activeItem = this.$el.querySelector('.el-tabs__item.is-active');
        if (!activeItem || !activeContinentBottom) return;
        activeContinentBottom.style.left = `${activeItem.offsetLeft + activeItem.offsetWidth / 2 - 8}px`;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.activity-country-nav-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 2px;
  width: 100%;
  .nav-list-left {
    width: 100%;
    /deep/ .el-tabs__header {
      margin: 0;
      border-bottom: none;

      .el-tabs__nav-next, .el-tabs__nav-prev {
        line-height: 32px;
      }

      .el-tabs__nav-scroll {
        padding: 0 0 5px 0;
      }
      .el-tabs__nav {
        .el-tabs__active-bar {
          width: 16px!important;
          height: 3px;
          bottom:-5px;
          background: rgba(255, 132, 66, .8);
          transform: translateX(0)!important;
          position: absolute;
          transition: 0.2s all;
        }
      }

      .el-tabs__item {
        font-size: 20px;
        color: #5F666E;
        line-height: 28px;
        margin-right: 32px;
        height: auto;
        padding: 0;
        &.is-active {
          color: #2F333D;
          font-weight: 600;
        }
      }
      
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activity/index-activity/activity-nav-list.vue